module.exports = __webpack_public_path__ + "static/img/functionPic.e87533ea.png";